module.exports = __webpack_public_path__ + "img/item-1.fbfa470.svg";